import { render, staticRenderFns } from "./charmScenario.vue?vue&type=template&id=4adf850a"
import script from "./charmScenario.vue?vue&type=script&lang=js"
export * from "./charmScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adf850a')) {
      api.createRecord('4adf850a', component.options)
    } else {
      api.reload('4adf850a', component.options)
    }
    module.hot.accept("./charmScenario.vue?vue&type=template&id=4adf850a", function () {
      api.rerender('4adf850a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/charmScenario.vue"
export default component.exports